module.exports = __webpack_public_path__ + "img/factory-icon-1.56d0005d.svg";